// Promo codes and credit vouchers.
//
// This only ever previews what a code is worth. The authoritative discount is
// recalculated on the server when the order is created, so a tampered preview
// buys nothing.

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  if (process.env.REACT_APP_API_KEY) {
    headers["X-API-Key"] = process.env.REACT_APP_API_KEY;
  }
  return headers;
};

/**
 * Validate a code against the booking in progress.
 *
 * Resolves to { valid: true, promotion } or { valid: false, reason }, where
 * `reason` is a stable key the UI maps to a translated message. A refused code
 * is a normal outcome, not an error.
 */
export const validatePromotion = async (code, booking = {}) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/promotions/validate`, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({
      code,
      rentalBase: Number(booking.rentalBase) || 0,
      addOnsTotal: Number(booking.addOnsTotal) || 0,
      bookingTotal: Number(booking.bookingTotal) || 0,
      nights: Number(booking.nights) || 0,
      customerEmail: booking.customerEmail || "",
    }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || "Failed to validate code");
  }
  return response.json();
};

export const PROMO_STORAGE_KEY = "checkoutPromoCode";

export const readStoredPromo = () => {
  try {
    const raw = sessionStorage.getItem(PROMO_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const storePromo = (promo) => {
  try {
    if (promo) {
      sessionStorage.setItem(PROMO_STORAGE_KEY, JSON.stringify(promo));
    } else {
      sessionStorage.removeItem(PROMO_STORAGE_KEY);
    }
  } catch {
    // Private browsing or blocked storage: the code is still sent with the
    // order, it just will not survive a reload.
  }
};
